import { render, staticRenderFns } from "./AllCancerUsers.vue?vue&type=template&id=22cedb5c&scoped=true&"
import script from "./AllCancerUsers.vue?vue&type=script&lang=js&"
export * from "./AllCancerUsers.vue?vue&type=script&lang=js&"
import style0 from "./AllCancerUsers.vue?vue&type=style&index=0&id=22cedb5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cedb5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VContainer,VDataTable,VFlex,VLayout,VPagination})
